import Layout from "../../components/layout"
import React from "react"
import { questionList } from "../../components/amiaworker/questions"
import forEach from "lodash/forEach"
import { useAmIAWorker } from "../../contexts/AmIAWorkerContext"
import { navigate } from "gatsby"

export default function AmIAWorkerLayout({ children, seo, currentPage }) {
  const progress = currentPage > 1 ? currentPage / 14 : 0
  const { setValues, amIAWorker } = useAmIAWorker()

  // If there is an incompleted question before current page, then go back to the start
  forEach(questionList, function (value, key) {
    // Question 5 isn't always completed as page 4 can skip to 6
    if (
      currentPage > key &&
      !amIAWorker?.[questionList[key].name] &&
      key != 5
    ) {
      if (typeof window !== `undefined`) {
        navigate("/amiaworker/")
      }
    }
  })

  return (
    <>
      <Layout seo={seo}>
        <div className="container mx-auto px-4 mb-12 mt-4 lg:px-12 min-h-0 md:am-i-a-worker ">
          <div className="text-2xl font-bold md:text-6xl mb-2 md:my-8">
            Are you a worker?
          </div>
          <p className="mb-2 md:mb-8 text-">
            Take our quiz to find out whether you are an employee, worker or
            self-employed.
          </p>

          <div className="mb-4 rounded-md p-2 text-sm md:text-lg md:p-4 shadow-xl h-full bg-white overflow-hidden justify-between border-gray-50 border md:max-w-screen-lg">
            Progress:{" "}
            {!!currentPage && currentPage <= 13 && (
              <span>{currentPage} / 13</span>
            )}
            {!!currentPage && currentPage > 13 && <span>Result</span>}
            <div className="relative pt-1">
              <div className="overflow-hidden h-2 mb-2 text-xs flex rounded bg-pink-200">
                <div
                  style={{ width: progress * 100 + "%" }}
                  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-800 "
                ></div>
              </div>
            </div>
          </div>
          {children}
        </div>
      </Layout>
    </>
  )
}
